/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindRoleQueryResponse } from './FindRoleQueryResponse';
import {
    FindRoleQueryResponseFromJSON,
    FindRoleQueryResponseFromJSONTyped,
    FindRoleQueryResponseToJSON,
} from './FindRoleQueryResponse';
import type { ListMeta } from './ListMeta';
import {
    ListMetaFromJSON,
    ListMetaFromJSONTyped,
    ListMetaToJSON,
} from './ListMeta';

/**
 * 
 * @export
 * @interface ListRoleQueryResponse
 */
export interface ListRoleQueryResponse {
    /**
     * 
     * @type {ListMeta}
     * @memberof ListRoleQueryResponse
     */
    meta: ListMeta;
    /**
     * 
     * @type {Array<FindRoleQueryResponse>}
     * @memberof ListRoleQueryResponse
     */
    data: Array<FindRoleQueryResponse>;
}

/**
 * Check if a given object implements the ListRoleQueryResponse interface.
 */
export function instanceOfListRoleQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "meta" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function ListRoleQueryResponseFromJSON(json: any): ListRoleQueryResponse {
    return ListRoleQueryResponseFromJSONTyped(json, false);
}

export function ListRoleQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListRoleQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': ListMetaFromJSON(json['meta']),
        'data': ((json['data'] as Array<any>).map(FindRoleQueryResponseFromJSON)),
    };
}

export function ListRoleQueryResponseToJSON(value?: ListRoleQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': ListMetaToJSON(value.meta),
        'data': ((value.data as Array<any>).map(FindRoleQueryResponseToJSON)),
    };
}

